
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M9.8 18.5c-.7-.6-.8-1.6-.2-2.3 0-.1.1-.1.1-.1l4.2-4.3H2c-.5 0-.9-.1-1.3-.4-.4-.4-.6-.9-.6-1.4.1-1 .9-1.7 1.8-1.7h11.9L9.7 4c-.4-.4-.6-.9-.5-1.3 0-.5.3-.9.6-1.2.3-.4.8-.5 1.2-.5.5 0 .9.2 1.3.5l7.1 7.3c.5.5.7 1.2.4 1.9l-.1.1-.6.5-6.8 7c-.7.8-1.8.9-2.5.2z"}})])
          )
        }
      }
    